export default __webpack_public_path__ + "static/media/mernstack.48b5c67d.png";